import Vue from 'vue';
import Slick from 'vue-slick';

function initVueInstance(element) {
    new Vue({
        el: element,

        delimiters: ['${', '}'],

        components: {
            Slick
        },

        data: {
            slickOptions: {
                slidesToShow: 1,
                arrows: true,
                dots: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                }]
            }
        }
    });
}

const selectHeroSlider = () => document.querySelectorAll('[vue-init-hero-slider]').forEach(element => {
    initVueInstance(element);
});
selectHeroSlider();

document.addEventListener("shopify:section:load", function() {
    selectHeroSlider();
});

